type DialogOpts = {
  onRefetch: () => void
  onDelete: (id: number) => void
};

const isOrderOpen = ref(false);
const orderDialogOptions = ref<DialogOpts>({
  onRefetch: () => null,
  onDelete: () => null
});

export function useOrderFormDialog(opts?: DialogOpts) {
  if (opts) {
    orderDialogOptions.value = opts;
  }

  const toggleOrderDialog = (state: boolean) => {
    isOrderOpen.value = state;
  };

  return {
    orderDialogOptions,
    isOrderOpen,
    toggleOrderDialog,
  };
}
